
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/s/itr-filing-for-nri-and-foreign-income",
      function () {
        return require("private-next-pages/cleartax.in/s/itr-filing-for-nri-and-foreign-income/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/s/itr-filing-for-nri-and-foreign-income"])
      });
    }
  